.contact-list {
    max-height: min(520px, calc(100vh - 240px));
    overflow: auto;
    padding: 0 0 0 8px;
}

.import-people-button-wrap > :global(button) {
    min-width: 150px;
}
